// extracted by mini-css-extract-plugin
export var closeButton = "_nb-2";
export var closeButtonIcon = "_nb-3";
export var lightboxContent = "_nb-1";
export var lightboxOverlay = "_nb-0";